:host {
  all: initial;
  color: #111827;
  font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  position: fixed;
  z-index: 2147483000;
}

*, *::before, *::after { box-sizing: border-box; }
button, a, input { font: inherit; }
button { cursor: pointer; }

.wq-bubble {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 320px;
  padding: 16px;
  border-radius: 22px;
  background:
    radial-gradient(circle at 18% 0%, rgba(255, 223, 174, 0.78), transparent 34%),
    linear-gradient(145deg, #fffaf1 0%, #fff 62%, #f4eadf 100%);
  box-shadow: 0 22px 60px rgba(30, 20, 12, 0.28);
  border: 1px solid rgba(75, 61, 51, 0.18);
  transform: translateY(0);
  opacity: 1;
}

.wq-enter {
  animation: wq-slide 300ms ease-out both;
}

.wq-bubble__header,
.wq-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wq-live {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.wq-live__dot {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  background: #10b981;
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.65);
  animation: wq-pulse 1.8s infinite;
}

.wq-icon-button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  background: rgba(75, 61, 51, 0.08);
  color: #4b3d33;
  font-size: 23px;
  line-height: 1;
}

.wq-icon-button:hover,
.wq-icon-button:focus-visible {
  background: #4b3d33;
  color: #fffaf1;
  outline: none;
}

.wq-bubble__visual {
  position: relative;
  overflow: hidden;
  height: 96px;
  margin: 12px 0 12px;
  border-radius: 18px;
  background: #eadfce;
  box-shadow: inset 0 0 0 1px rgba(75, 61, 51, 0.08);
}

.wq-bubble__visual img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.wq-bubble__visual::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 45%, rgba(35, 24, 16, 0.32));
  pointer-events: none;
}

.wq-bubble__visual span {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
  font-size: 54px;
}

.wq-bubble h2 {
  margin: 0 0 8px;
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
}

.wq-bubble__question {
  margin: 0 0 16px;
  color: #374151;
  font-size: 15px;
  line-height: 1.45;
}

.wq-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.wq-actions button {
  min-height: 48px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  color: #1f2937;
  font-weight: 800;
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease, color 160ms ease;
}

.wq-actions button:hover,
.wq-actions button:focus-visible {
  transform: translateY(-1px);
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  outline: none;
}

.wq-overlay {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(17, 24, 39, 0.5);
  animation: wq-fade 200ms ease-out both;
}

.wq-modal {
  width: min(480px, 100%);
  max-height: 90vh;
  overflow: auto;
  border-radius: 24px;
  background: #fffaf1;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.3);
}

.wq-modal__header {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(75, 61, 51, 0.12);
  background: rgba(255, 250, 241, 0.94);
  backdrop-filter: blur(10px);
}

.wq-hearts {
  color: #ef4444;
  font-size: 19px;
  letter-spacing: 3px;
}

.wq-hearts .is-empty {
  color: #d1d5db;
}

.wq-streak {
  color: #374151;
  font-size: 14px;
  font-weight: 800;
}

.wq-modal__body {
  padding: 22px;
}

.wq-item {
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 18px;
  background: #fff;
  text-align: center;
  transition: border-color 180ms ease, background 180ms ease, transform 180ms ease;
}

.wq-item.is-right {
  border-color: #10b981;
  background: #ecfdf5;
}

.wq-item.is-wrong {
  border-color: #ef4444;
  background: #fef2f2;
}

.wq-eyebrow {
  margin: 0 0 8px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.wq-emoji {
  font-size: 48px;
  line-height: 1;
}

.wq-item h3 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 10px 0 4px;
  color: #111827;
  font-size: 18px;
  font-weight: 900;
}

.wq-weight {
  margin: 0;
  color: #4b3d33;
  font-size: 24px;
  font-weight: 900;
}

.wq-vs {
  margin: 12px 0;
  color: #6b7280;
  text-align: center;
  font-weight: 900;
}

.wq-modal-question {
  margin: 18px 0 10px;
  color: #111827;
  text-align: center;
  font-size: 18px;
  font-weight: 900;
}

.wq-modal-question.is-right { color: #047857; }
.wq-modal-question.is-wrong { color: #b91c1c; }

.wq-fact {
  margin: 0 0 14px;
  color: #6b7280;
  text-align: center;
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}

.wq-actions--modal button,
.wq-primary,
.wq-gameover button {
  min-height: 56px;
  border: 2px solid #2563eb;
  border-radius: 16px;
  background: #fff;
  color: #2563eb;
  font-size: 18px;
  font-weight: 900;
}

.wq-auto-next {
  grid-column: 1 / -1;
  margin: 0;
  min-height: 44px;
  display: grid;
  place-items: center;
  color: #6b7280;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wq-actions--modal button:hover,
.wq-primary:hover,
.wq-gameover button:hover,
.wq-actions--modal button:focus-visible,
.wq-primary:focus-visible,
.wq-gameover button:focus-visible {
  background: #2563eb;
  color: #fff;
  outline: none;
}

.wq-gameover {
  display: grid;
  gap: 14px;
  text-align: center;
}

.wq-gameover-title {
  margin: 8px 0 0;
  font-size: 34px;
  line-height: 1.05;
}

.wq-gameover-streak {
  margin: 0;
  color: #374151;
  font-size: 17px;
}

.wq-emoji-grid {
  overflow-wrap: anywhere;
  margin: 0 auto;
  max-width: 16ch;
  font-size: 28px;
  line-height: 1.35;
}

.wq-gameover a {
  color: #dc4d3a;
  font-size: 15px;
  font-weight: 900;
  text-decoration: none;
}

.wq-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 56px;
  height: 56px;
  border: 0;
  border-radius: 999px;
  background: #4b3d33;
  color: #fffaf1;
  box-shadow: 0 14px 40px rgba(30, 20, 12, 0.28);
  font-size: 25px;
}

.wq-fab span {
  position: absolute;
  right: -4px;
  top: -4px;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border-radius: 99px;
  background: #2563eb;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  line-height: 22px;
}

.wq-toast {
  position: fixed;
  right: 24px;
  bottom: 92px;
  padding: 10px 14px;
  border-radius: 999px;
  background: #111827;
  color: #fff;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.24);
  font-size: 13px;
  font-weight: 800;
}

.wq-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

@keyframes wq-slide {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes wq-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes wq-pulse {
  0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.65); }
  70% { box-shadow: 0 0 0 9px rgba(16, 185, 129, 0); }
  100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

@media (max-width: 767px) {
  .wq-bubble {
    right: 16px;
    left: 16px;
    bottom: 16px;
    width: auto;
  }

  .wq-actions {
    grid-template-columns: 1fr;
  }

  .wq-overlay {
    padding: 0;
  }

  .wq-modal {
    width: 100%;
    height: 100%;
    max-height: none;
    border-radius: 0;
  }

  .wq-modal__body {
    padding: 18px 16px max(22px, env(safe-area-inset-bottom));
  }
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
  }
}
